import { render } from "./Registry.vue?vue&type=template&id=7cf5c8b6"
import script from "./Registry.vue?vue&type=script&lang=js"
export * from "./Registry.vue?vue&type=script&lang=js"

import "./Registry.vue?vue&type=style&index=0&id=7cf5c8b6&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__